import React from "react";
import Menu from "./Menu";
import Navigation from "./Navigation";

const Header = () => {
  return (
    <div>
      <Navigation />
      <Menu />
    </div>
  );
};

export default Header;
